import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_release_job",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "add_job",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_release_job_button",
  "data-kt-drawer-close": "#kt_drawer_release_job_close",
  "data-kt-drawer-width": "50.5vw"
}
const _hoisted_2 = {
  id: "kt_release_job",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_release_job_header\"><h2 class=\"fw-bolder text-light my-auto\"> Release Job Placement </h2><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_release_job_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_release_job_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_release_job_body",
  "data-kt-scroll-dependencies": "#kt_release_job_header, #kt_release_job_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = ["validation-schema"]
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_release_job_scroll"
}
const _hoisted_8 = { class: "row mb-7" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Release Date", -1)
const _hoisted_11 = {
  class: "card-footer py-5 text-center",
  id: "kt_release_job_footer"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_drawer_release_job_close",
  class: "btn btn-danger me-5"
}, " Close ", -1)
const _hoisted_13 = ["data-kt-indicator"]
const _hoisted_14 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_15 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_16 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "card-body p-2",
                "validation-schema": _ctx.TraineeListSchema
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_el_form_item, { class: "mb-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.release_date,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.release_date) = $event)),
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            type: "date",
                            name: "dob",
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ], 8, _hoisted_6),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_15, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_17
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_13)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ]))
}